<div
  class="row section clinical-feedback-section mt-3 section-row"
  [formGroupName]="formControlName"
>
  <div class="section-container">
    <div class="row section-row">
      <div class="col section-col">
        <h5 class="section-heading">Attachments</h5>
      </div>
    </div>
    <div class="row section-row">
      <div class="col-12 section-col">
        <app-file-upload
          [accessionNumber]="accessionNumber"
          [id]="formElementModels['attachments'].id"
          [formElementModel]="formElementModels['attachments']"
          [parentFormGroup]="formGroup"
        >
        </app-file-upload>
      </div>
    </div>
  </div>
</div>
